import { graphql } from "gatsby"
import tw, { styled } from "twin.macro"
import { withArtDirection, getImage, GatsbyImage } from "gatsby-plugin-image"
import Sandbox from "../atoms/sandbox"
import FloatingBox from "../atoms/floating-box"
import ContentWrapper from "../atoms/content-wrapper"
import { themeStyles } from "../../styles/theme-helpers"
import PreHeader from "../atoms/pre-header"

const mqs = {
  portrait: "(min-width: 568px)",
}
const FeatureImageWrapper = styled.div`
  position: relative;
  padding-bottom: 100%;

  @media ${mqs.portrait} {
    padding-bottom: ${(16 / 9) * 100}%;
  }
`

const FeatureTextWrapper = styled(ContentWrapper)`
  @media ${mqs.portrait} {
    ${tw`flex items-center py-6`}
  }
`

const FeatureImageFloatingBox = styled(FloatingBox)`
  @media ${mqs.portrait} {
    ${tw`w-1/2 flex-shrink-0 flex-grow-0`}
  }
`

const FeatureImage = styled(GatsbyImage)`
  ${tw`!absolute !inset-0`}
`

const FTextContent = styled.div`
  ${tw`px-4 -mt-12 pb-12`}
  @media ${mqs.portrait} {
    ${tw`mt-0 flex-grow`}
  }
  @media (min-width: 1024px) {
    ${tw`pl-12 pr-16`}
  }
`

const FeatureText = ({ data }) => {
  const theme = data.theme?.name || "mist"
  const images = withArtDirection(getImage(data.square.localFile), [
    {
      media: mqs.portrait,
      image: getImage(data.portrait.localFile),
    },
  ])
  const tearColor = theme === "white" ? "mist" : "white"

  return (
    <div css={[themeStyles[theme]]}>
      <FeatureTextWrapper>
        <FeatureImageFloatingBox range={0.5}>
          <FeatureImageWrapper>
            <FeatureImage image={images} alt={data.square.alternativeText} />
          </FeatureImageWrapper>
        </FeatureImageFloatingBox>
        <FTextContent>
          <div
            css={[
              tw`relative p-6 text-brand-black`,
              theme === "white" ? tw`bg-brand-light_mist` : tw`bg-white`,
            ]}
            className={`tear-t-sm-${tearColor} tear-b-sm-${tearColor}`}
          >
            {data.header && <PreHeader>{data.header}</PreHeader>}
            <div tw="font-display text-2xl leading-none mb-4 sm:(text-3xl leading-none)">
              {data.title}
            </div>
            <Sandbox dangerouslySetInnerHTML={{ __html: data.text }} />
          </div>
        </FTextContent>
      </FeatureTextWrapper>
    </div>
  )
}

export const query = graphql`
  fragment FeatureText on FT_ComponentMoleculesFeatureText {
    id
    title
    text
    header
    theme {
      name
    }
    square: image {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(
            aspectRatio: 1
            width: 568
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
    portrait: image {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(
            aspectRatio: 0.5625
            width: 480
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  }
`

export default FeatureText
